<div class="upload-model">
  <div class="upload-title">Upload Product(s) to the Early Advantage Order</div>
  <p class="help-text">Click on the "Select File" button to upload a spreadsheet from your computer.</p>
  <div class="row">
    <div class="col-md-12 d-none d-sm-none d-md-block ml-3">
      <input type="file" class="custom-file-input" id="importFile"
             accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
             (change)="onFileSelect($event)" #UploadFileInput>
      <label class="custom-file-label width-upload-60" for="customFile">{{fileInputLabel  || 'Choose File'}}</label>
      <!--<button mat-raised-button class="btns">Select File</button>-->
    </div>
  </div>
  <p class="help-text mt-2">
    (Accepted formats: .xls .xlsx .csv)
  </p>
  <div class="position-relative">
    <span class="download-icon-class"></span>
    <u><a class="download-text ml-4" (click)="getUploadTemplate()">Download SpreadSheet Template</a></u>
  </div>
  <div class="d-flex justify-content-end help-text"><span class="font-weight-bold">Need help?</span><a class="help-text pl-1" href="tel:1-855-494-6343">1-855-494-6343</a></div>
  <div class="position-relative">
    <span class="close-btn position-absolute" (click)="CloseDialog()">
      <i class="fas fa-times"></i>
    </span>
  </div>
</div>
